module.exports = __webpack_public_path__ + "static/media/10.2cd6eb06.png";